define('modules/wishlist-products',[
  'jquery',
  'connections/wishlist-connection',
  'server-settings'
], function($, WishListConnection, serverSettings) {
  return (function() {
    var _this;

    function WishListProducts(wishListProductsView) {
      _this = this;
      _this.$wishListProductsView = wishListProductsView;
      _this.$list = wishListProductsView.find('.wishlist-products__list');
      _this.$clearBtn = wishListProductsView.find(
        '.wishlist-products__clear-btn'
      );

      _this.hideHeaderSection();
    }

    WishListProducts.prototype.toggleProduct = function(e) {
      e.preventDefault();
      e.stopPropagation();

      var element = this;
      if (element.classList.contains('added')) {
        element.classList.remove('added');
        element.classList.remove('icon-heart');
        element.classList.add('icon-heart-empty');
        WishListConnection.removeProduct($(element).data('sku')).then(function(
          response
        ) {
          if (response.success) {
            WishListConnection.list().then(function(view) {
              _this.$list.show();
              _this.$list.html(view);
              if (_this.$list.children().length == 0) {
                _this.$clearBtn.hide();
              }
            });
          } else {
            element.classList.add('added');
            element.classList.add('icon-heart');
            element.classList.remove('icon-heart-empty');
          }
        });
      } else {
        element.classList.add('added');
        element.classList.add('icon-heart');
        element.classList.remove('icon-heart-empty');
        WishListConnection.addProduct(element.dataset.sku).then(function(
          response
        ) {
          if (response.success) {
            WishListConnection.list().then(function(view) {
              _this.showHeaderSection();
              _this.$list.show();
              _this.$list.html(view);
              _this.$clearBtn.show();
            });
          } else {
            element.classList.remove('added');
            element.classList.remove('icon-heart');
            element.classList.add('icon-heart-empty');
          }
        });
      }
    };

    WishListProducts.prototype.removeProduct = function(e) {
      e.preventDefault();
      e.stopPropagation();

      var element = this;

      var btn = $(
        ".wishlist_toggle.added[data-sku='" + $(element).data('sku') + "']"
      );
      btn.removeClass('added');
      btn.removeClass('icon-heart');
      btn.addClass('icon-heart-empty');

      $(element)
        .parent()
        .hide();

      WishListConnection.removeProduct($(element).data('sku')).then(function(
        response
      ) {
        if (response.success) {
          WishListConnection.list().then(function(view) {
            _this.$list.show();
            _this.$list.html(view);
            if (_this.$list.children().length == 0) {
              _this.$clearBtn.hide();
            }
          });
        }
      });
    };

    WishListProducts.prototype.resetWishList = function(e) {
      e.preventDefault();
      e.stopPropagation();

      _this.$list.hide();
      _this.$clearBtn.hide();
      WishListConnection.resetWishList().then(function(response) {
        if (response.success) {
          _this.$list.empty();

          $('.wishlist_toggle.added').removeClass('icon-heart');
          $('.wishlist_toggle.added').addClass('icon-heart-empty');
          $('.wishlist_toggle.added').removeClass('added');
        } else {
          _this.$list.show();
          _this.$clearBtn.show();
        }
      });
    };

    WishListProducts.prototype.showHeaderSection = function() {
      _this.$wishListProductsView.show();
    };

    WishListProducts.prototype.hideHeaderSection = function() {
      if (_this.$list.children().length == 0) {
        _this.$wishListProductsView.hide();
      }
    };

    WishListProducts.prototype.initBindings = function() {
      $(document).on('click', '.wishlist_toggle', _this.toggleProduct);
      $(document).on(
        'click',
        '.wishlist-products__item-remove',
        _this.removeProduct
      );

      _this.$clearBtn.on('click', _this.resetWishList);
    };

    return WishListProducts;
  })(this);
});

